export default "__VITE_ASSET__88bdf3e2__"